export default function ProfileExperienceTab({ details }) {
  return (
    <>
      <div className="profile-tab-all experience-tab-all">
        <div className="profile-single-all certifications-single-all-wrapper">
          <span>Certifications</span>
          <div className="separator"></div>
          <div className="profile-certification-wrapper">
            {details.certificates.length === 0 ? (
              <p>No certificates</p>
            ) : (
              details.certificates.map((curr) => (
                <div className="certificates-single" key={curr.id}>
                  <div className="certificates-single__year">
                    {curr.year_finished}
                  </div>
                  <div className="certificates-single__title">{curr.name}</div>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="profile-single-all experience-tab-all">
          <span>Experience</span>
          <div className="separator"></div>
          <div className="profile-certification-wrapper">
            {details.experiences.length === 0 ? (
              <p>No experiences</p>
            ) : (
              details.experiences.map((curr) => {
                return (
                  <div
                    className="experience-certification-wrapper"
                    key={curr.id}
                  >
                    <div className="experience-company-name">
                      <span>Company</span>
                      <p>{curr.company_name}</p>
                    </div>
                    {curr.role && (
                      <div className="experience-role">
                        <p>{curr.role}</p>
                      </div>
                    )}

                    <div className="experience-company-description">
                      <p>{curr.description}</p>
                    </div>
                    {curr.date_start && (
                      <div className="teneture-company-wrapper">
                        <span>Teneture</span>
                        <div className="teneture-company-date">
                          <p>{curr.date_start}</p>-<p>{curr.date_end}</p>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}
